export default __webpack_public_path__ + "static/media/cloth_07.6ae736c8.jpg";